mutation DeleteOrganizations($ids: [ID!]!) {
  deleteOrganizations(ids: $ids) {
    id
    deleted
    deletedAt
  }
}

